import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  Film,
  Tags,
  LayoutPanelTop,
  Users,
  BarChart3,
  LogOut
} from 'lucide-react';
import { useAdminAuth } from './AdminAuthContext';

const nav = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/movies', label: 'Movies', icon: Film },
  { to: '/collections', label: 'Collections', icon: Tags },
  { to: '/homepage-slider', label: 'Homepage slider', icon: LayoutPanelTop },
  { to: '/subscribers', label: 'Subscribers', icon: Users },
  { to: '/analytics', label: 'Analytics', icon: BarChart3 }
];

export default function AdminLayout() {
  const { signOut, profile } = useAdminAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  return (
    <div className="bg-zinc-950 text-zinc-100">
      <aside className="fixed inset-y-0 left-0 z-30 flex h-screen w-56 flex-col border-r border-zinc-800 bg-zinc-900/50">
        <div className="shrink-0 border-b border-zinc-800 p-4">
          <div className="text-sm font-semibold text-white">Noilio</div>
          <div className="text-xs text-zinc-500 mt-0.5">Admin</div>
        </div>
        <nav className="min-h-0 flex-1 space-y-0.5 overflow-y-auto p-2">
          {nav.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition-colors ${
                  isActive
                    ? 'bg-violet-600/20 text-violet-300'
                    : 'text-zinc-400 hover:bg-zinc-800 hover:text-zinc-200'
                }`
              }
            >
              <Icon className="h-4 w-4 shrink-0" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="shrink-0 border-t border-zinc-800 p-3 text-xs text-zinc-500">
          <div className="truncate mb-2" title={profile?.role}>
            Role:{' '}
            <span className="text-zinc-300 capitalize">
              {profile?.role?.replace('_', ' ') || '—'}
            </span>
          </div>
          <button
            type="button"
            onClick={handleSignOut}
            className="flex items-center gap-2 w-full rounded-lg px-2 py-1.5 text-left text-zinc-400 hover:bg-zinc-800 hover:text-white"
          >
            <LogOut className="h-3.5 w-3.5" />
            Sign out
          </button>
        </div>
      </aside>
      <main className="ml-56 h-screen overflow-y-auto overscroll-contain">
        <div className="mx-auto max-w-7xl p-6 lg:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
